import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/annual-return/client/AnnualReturnClient.tsx");
